import React, { useState } from "react";
import S from "./People.styled";

import { Flex, MainInner, MainSection, motionAnimation } from "@/styles/global";
import { Body, H3, SmallHeading1 } from "@/styles/typography";
import { BackgroundImage } from "@/styles/components";
import { IStaff, IWPTitleParts } from "@/src/types";
import Email from "@/assets/email.svg";
import LinkedIn from "@/assets/linkedin_2.svg";
import Phone from "@/assets/phone.svg";
import Date from "@/assets/date.svg";
import TitleParts from "@/components/global-components/TitleParts";
import { motion } from "framer-motion";
export interface PeopleProps {
  blockId: string;
  titleParts: IWPTitleParts;
  title: string;
  staff: IStaff;
}

const People: React.FC<PeopleProps> = ({
  titleParts,
  title,
  staff,
  blockId = "",
}) => {
  const [active, setActive] = useState<number | undefined>(undefined);

  const renderStaff = staff?.map(({ staffInfo }, i) => {
    const {
      image,
      firstName,
      lastName,
      position,
      email,
      bio,
      phone,
      calendly,
      linkedin,
    } = staffInfo;
    return (
      <S.Card
        key={i}
        onClick={() => (active === i ? setActive(undefined) : setActive(i))}
        onMouseOver={() => setActive(i)}
        onMouseLeave={() => setActive(undefined)}
      >
        {image && (
          <>
            <BackgroundImage image={image} />
            <S.Overlay $active={active === i} />
          </>
        )}

        <S.TextWrapper>
          {active !== i ? (
            <>
              <div />

              <S.NamePositionWrapper>
                {firstName && lastName && (
                  <H3 color="white">
                    {firstName} {lastName}
                  </H3>
                )}

                {position && (
                  <Body color="white" size={16} margin="8px 0 0 0">
                    {position}
                  </Body>
                )}
              </S.NamePositionWrapper>
            </>
          ) : (
            <Flex $column $justify="between" $height="100%">
              <Body color="white" size={16}>
                {bio}
              </Body>
              <S.IconWrapper>
                {email && (
                  <S.IconLink target="_blank" href={`mailto:${email}`}>
                    <Email />
                  </S.IconLink>
                )}
                {phone && (
                  <S.IconLink href={`tel:${phone}`}>
                    <Phone />
                  </S.IconLink>
                )}

                {linkedin && (
                  <S.IconLink target="_blank" href={linkedin}>
                    <LinkedIn />
                  </S.IconLink>
                )}

                {calendly && (
                  <S.IconLink target="_blank" href={calendly}>
                    <Date />
                  </S.IconLink>
                )}
              </S.IconWrapper>
            </Flex>
          )}
        </S.TextWrapper>
      </S.Card>
    );
  });

  return (
    <S.Section id={blockId} as={motion.section} {...motionAnimation}>
      <MainInner>
        <SmallHeading1>
          {titleParts ? (
            <TitleParts titleParts={titleParts} backgroundColor="white" />
          ) : (
            title && title
          )}
        </SmallHeading1>
      </MainInner>
      <S.Container>
        <S.CardWrapper>{renderStaff}</S.CardWrapper>
      </S.Container>
    </S.Section>
  );
};

export default People;
